// The widget's OWN build identity, injected at build time by Vite's `define`
// (`__WIDGET_BUILD_VERSION__` in vite.main.config.mjs) as `<branch>-<sha7>` — so a
// build off master reports `master-32cda02` and one off a topic branch reports
// `fix-widget-build-identity-d46dd4c`. Reported to Faro as `app_version`.
//
// 🔴 THIS USED TO BE A RUNTIME FETCH of `/WEBWIDGETV2-VERSION.txt`, and it was wrong
// in two independent ways:
//
//   1. The marker is DEPRECATED. Builder-port S2/S3 replaced `WEBWIDGET-VERSION`,
//      `WEBWIDGETV2-VERSION.txt` and `MAIN-BUNDLE.txt` with the one structured
//      `widget-version.json` manifest, the three becoming shims to be "retired once
//      nothing reads them". A fetch from the shipped bundle is the hardest reader of
//      all to retire, because it is live customer traffic rather than a build script.
//      (The host literals are deliberately not written out here — `hosts.spec.js`
//      centralises them in config/hosts.js and scans comments too.)
//   2. It never worked on prod. That path 404s at the cluster root on BOTH production
//      hostnames. MEASURED in Faro RUM on 2026-08-20: `app_version=dev` on 107,231 of
//      107,233 events over 13 hours, and 14,084 fetches of an 80-byte 404 page — the
//      widget's most-requested single URL. (NOT "ahead of the playlist" — an earlier
//      telling said that and it is wrong: `widget.json` outnumbers it once its variants
//      are summed. The marker still tops the per-URL table, which is the true and
//      sufficient claim.) `initFaro` was
//      chained onto that fetch, so RUM stayed blind for p90 551.7ms of every load
//      awaiting a guaranteed failure.
//
// The old code's stated reason for reading at runtime — "never baked into the bundle,
// since one build serves every cluster" — conflated two separate things. The COLLECTOR
// HOST is genuinely cluster-specific and is still derived at runtime, from
// `window.location.hostname` (see `resolveFaroCollectorHost`). The BUILD IDENTITY is a
// property of the BUILD: one build serving every cluster is precisely the reason it CAN
// be baked, and the reason a baked value cannot be wrong on some cluster.
//
// The `typeof` guard mirrors `featureFlags.js`'s FORCE_V4 — it keeps this `''` in any
// context WITHOUT the define (unit tests, the dev server, a build that forgot to set
// it), which `deriveFaroConfig` then reports as its own 'dev' fallback. No `??` (the
// pinned ES2015 `src/` ban); the guard is written the ES2015 way.
export const BUILD_VERSION =
  typeof __WIDGET_BUILD_VERSION__ !== 'undefined' ? __WIDGET_BUILD_VERSION__ : '';
